var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Button, Modal, Space, TextHeading, useModal, } from '@ally/metronome-ui';
import { CallUsBlock } from '../Components/LoginShared';
import { useFlagContextValue } from '../FlagContext';
var headingRef = React.createRef();
var ModalContent = function (_a) {
    var _b = _a.shouldShowAllLOBs, shouldShowAllLOBs = _b === void 0 ? false : _b;
    var variation = useFlagContextValue().variation;
    return (React.createElement(React.Fragment, null,
        React.createElement(Space, { mb: "md" },
            React.createElement(TextHeading, { tag: "h1", size: "md", tabIndex: -1, ref: headingRef }, "Give us a call.")),
        React.createElement(Space, { mb: "md" },
            React.createElement(CallUsBlock, { shouldShowAllLOBs: shouldShowAllLOBs, variation: variation }))));
};
var ModalTriggerComponent = function (_a) {
    var triggerContent = _a.triggerContent;
    var showModal = useModal().showModal;
    return (React.createElement(Button, { withAllyTM: "callUs", variant: "link", text: triggerContent, onClick: showModal }));
};
export var CallUsModal = function (_a) {
    var _b = _a.disableTrigger, disableTrigger = _b === void 0 ? false : _b, context = _a.context, _c = _a.shouldShowAllLOBs, shouldShowAllLOBs = _c === void 0 ? false : _c, _d = _a.triggerContent, triggerContent = _d === void 0 ? 'call' : _d;
    return (React.createElement(Modal, __assign({ content: React.createElement(ModalContent, { shouldShowAllLOBs: shouldShowAllLOBs }), ref: headingRef, trigger: disableTrigger ? undefined : (React.createElement(ModalTriggerComponent, { triggerContent: triggerContent })) }, (context ? { context: context } : {}))));
};
//# sourceMappingURL=CallUsModal.js.map